import { messageIdProvider, registerTranslationDivisions } from "infrastructure/localization";

export const releaseDivision = "release";

registerTranslationDivisions([releaseDivision]);

export const releaseMessages = messageIdProvider(releaseDivision);
